import React from 'react';
import PropTypes from 'prop-types';
import { Container } from 'components/base';

import { Picture, imageShape } from './shared';

// Customer quote with its photo. Phones show the photo as the byline avatar only.
const LandingStory = ({ image, quote, author, product }) => (
  <section className="lnd-story">
    <Container className="lnd-story-inner">
      <div className="lnd-story-photo">
        <Picture image={image} sizes="(min-width: 992px) 460px, 44px" />
      </div>
      <figure className="lnd-story-quote">
        <span className="lnd-story-mark" aria-hidden="true">
          “
        </span>
        <blockquote className="lnd-story-text">{quote}</blockquote>
        <figcaption className="lnd-story-byline">
          <span className="lnd-story-avatar" aria-hidden="true">
            <Picture image={image} sizes="44px" alt="" />
          </span>
          <span>
            <span className="lnd-story-author">{author}</span>{' '}
            <span className="lnd-story-on">on {product}</span>
          </span>
        </figcaption>
      </figure>
    </Container>
  </section>
);

LandingStory.propTypes = {
  image: imageShape.isRequired,
  quote: PropTypes.string.isRequired,
  author: PropTypes.string.isRequired,
  product: PropTypes.string.isRequired,
};

export default LandingStory;
